
import AppleIcon from "!url-loader!./icons/apple-podcasts.svg";
import CastBoxIcon from "./icons/castbox.webp";
import GooglePodcastsIcon from "!url-loader!./icons/apple-podcasts.svg";
import OvercastIcon from "./icons/overcast.png";
import iHeartIcon from "./icons/iheart_radio.png";
import PocketCastsIcon from "./icons/pocket-casts.png";
import PodcastAddictIcon from "./icons/podcast-addict.png";
import RssIcon from "!url-loader!./icons/rss.svg";
import SpotifyIcon from "!url-loader!./icons/spotify.svg";

export const icons = {
    "apple-podcasts.svg": <img src={AppleIcon} />,
    "castbox.webp": <img src={CastBoxIcon} />,
    "google-podcasts.svg": <img src={GooglePodcastsIcon} />,
    "overcast.png": <img src={OvercastIcon} />,
    "pocket-casts.png": <img src={PocketCastsIcon} />,
    "podcast-addict.png": <img src={PodcastAddictIcon} />,
    "rss.svg": <img src={RssIcon} />,
    "spotify.svg": <img src={SpotifyIcon} />,
    "iheart_radio.png": <img src={iHeartIcon} />,
};

